import { render, staticRenderFns } from "./HeaderMore.vue?vue&type=template&id=2ca42156&scoped=true&"
import script from "./HeaderMore.vue?vue&type=script&lang=js&"
export * from "./HeaderMore.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMore.vue?vue&type=style&index=0&id=2ca42156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca42156",
  null
  
)

export default component.exports